<section class="gradient position-relative">
    <div class="container pt-5 pt-lg-6">
        <div class="row">
            <div class="col-12 mb-5">
                <div [innerHtml]="body()?.primary?.heading | renderHtml : headingSerializer"></div>
                <div [innerHtml]="body()?.primary?.title | renderHtml : titleSerializer"></div>
            </div>
        </div>
    </div>

    <div class="swiper-fullwidth">
        <swiper-container appSwiper #swiper [config]="swiperConfig" init="false">
            @for (item of body()?.items; track $index) {
            <swiper-slide>
                <div class="background-white rounded-4 p-4 p-lg-5 h-100 d-flex flex-column justify-content-between">
                    <div class="position-relative">
                        <div class="d-flex justify-content-between">
                            @if (item?.icon?.url ||item?.emoji) { @if (item?.emoji) {
                            <p class="text-size-l">{{ item?.emoji }}</p>
                            } @else {
                            <img [src]="item?.icon?.url" [alt]="item?.icon?.alt" class="icon-big mb-4" />
                            } @if (item?.badge) {
                            <div class="badge-pink d-flex align-items-center">
                                @if (item?.badge_icon?.url) {
                                <img height="12px" width="12px" [src]="item?.badge_icon?.url" [alt]="item?.badge_icon?.alt" class="me-1" />
                                }
                                <div>{{ item?.badge }}</div>
                            </div>
                            } }
                        </div>
                        <p class="mb-0 color-pink fw-bolder text-size-xs">{{ item?.heading }}</p>
                        @if (item?.link) {
                        <app-link [link]="item?.link" cssClass="stretched-link">
                            <div [innerHTML]="item?.title | renderHtml : htmlSerializer"></div>
                        </app-link>
                        } @else {
                        <div [innerHTML]="item?.title | renderHtml : htmlSerializer"></div>
                        }
                        <div [innerHTML]="item?.description | renderHtml"></div>
                    </div>
                </div>
            </swiper-slide>
            }
        </swiper-container>
    </div>
    <div class="container py-5 pb-lg-6">
        <div class="row">
            <div class="col-12">
                <div class="navigation-buttons d-flex justify-content-end">
                    <div class="swiper-button-prev me-4" (click)="prev()">
                        <img src="assets/images/arrow-right.svg" alt="Nach links" class="rotate-180 w-100" />
                    </div>
                    <div class="swiper-button-next" (click)="next()">
                        <img src="assets/images/arrow-right.svg" alt="Nach Rechts" class="w-100" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
